// extracted by mini-css-extract-plugin
module.exports = {"topNewsItem":"BPjr","index":"BPjt","content":"BPbd","header":"BPap","statisticBlock":"BPa3"};